import Pusher, { type ChannelAuthorizationCallback } from "pusher-js";

import { Env } from "../env";
import { useInit } from "./epox/utils";
import { api } from "./api";

Pusher.logToConsole = Env.debug;

// TODO: Channel authorization Epox
type ChannelAuthorizationRequestParams = {
  socketId: string;
  channelName: string;
};

type ChannelAuthorizationReq = {
  socket_id: string;
  channel_name: string;
};

type ChannelAuthorizationRes = {
  auth: string;
};

function authorizeChannel(req: ChannelAuthorizationReq) {
  return api.post<ChannelAuthorizationRes, ChannelAuthorizationReq>(
    "broadcasting/auth",
    req
  );
}

async function channelAuthorizationHandler(
  params: ChannelAuthorizationRequestParams,
  callback: ChannelAuthorizationCallback
) {
  try {
    const res = await authorizeChannel({
      socket_id: params.socketId,
      channel_name: params.channelName,
    });

    callback(null, res);
  } catch (err: unknown) {
    callback(err as unknown as Error, null);
  }
}

const pusher = new Pusher(Env.pusherAppKey, {
  cluster: Env.pusherCluster,
  forceTLS: !Env.debug,
  channelAuthorization: {
    endpoint: "", // Not used.
    transport: "ajax", // Not used.
    customHandler: channelAuthorizationHandler,
  },
});

type UserChannelOptions = {
  onBooking?: () => void;
  onChatMessage?: () => void;
  onOffline?: () => void;
};

export function subscribeToUserChannel(
  userId: number,
  options?: UserChannelOptions
) {
  const channel = pusher.subscribe(`private-models.${userId}`);

  if (options?.onBooking) {
    channel.bind("booking", options.onBooking);
  }

  if (options?.onChatMessage) {
    channel.bind("message.created", options.onChatMessage);
    channel.bind("message.read", options.onChatMessage);
  }

  if (options?.onOffline) {
    channel.bind("offline", options.onOffline);
  }
}

export function unsubscribeFromUserChannel(userId: number) {
  pusher.unsubscribe(`private-models.${userId}`);
}

type ChatChannelOptions = {
  onTyping?: () => void;
};

export function useChatChannel(chatId: number, options?: ChatChannelOptions) {
  // Vars
  const channelName = `private-chats.${chatId}`;
  const channel = pusher.subscribe(channelName);

  if (options?.onTyping) {
    channel.bind("client-typing", options.onTyping);
  }

  // Effects
  useInit(() => () => {
    // Clean up
    pusher.unsubscribe(channelName);
  });

  // API
  return function broadcastTyping() {
    channel.trigger("client-typing", { chatId });
  };
}
